/**
 * Адаптер за antd theme токени и заварените inline теми.
 * Семействата се определят само в typography.css; новият UI ползва
 * Tailwind font-sans / font-mono (или модулните им алиаси).
 */
export const fontFamilies = {
  sans: "var(--font-sans)",
  mono: "var(--font-mono)",
} as const;
